module.exports = __webpack_public_path__ + "img/mz.5a4a3d8.svg";